import {EXTERNAL_FILE_TYPE} from 'constants/PreviewTypeConstants';
import {NoteLinkedGroupKind, NoteLinkedGroup} from 'notebook/notes/groups/NoteLinkedGroupConstants';
import {isNoteLinkedFile} from 'notebook/TypePredicates';
import {
  FromServerNoteLinkedFile,
  NoteLinkedObject,
  NoteLinkedObjectType,
  NotePart,
  NotePartWithItem,
  NoteLinkedFile,
  isNotePartWithItem,
} from 'notebook/util/NoteUtilConstants';

export const MIN_ITEM_WIDTH = 150;
export const MAX_ITEM_WIDTH = 400;

// Horizontal chrome around grid-contained images: 2 * (1px border + 4px padding) = 10px.
export const GRID_CONTAINED_IMAGE_PADDING = 10;

export interface NotePartGridGroupMetadata {}

export interface GridImageTask {
  taskId: string;
  fileUploadDeferred: JQueryPromise<FromServerNoteLinkedFile>;
  fileName?: string;
}

export interface CreateNotePartGridGroupExtras {
  gridImageTasks?: Array<GridImageTask>;
}

export interface GridPlaceholderNotePart extends NotePart {
  _fileUploadDeferred?: JQueryPromise<FromServerNoteLinkedFile>;
  _fileName?: string;
}

export type NotePartGrid = NoteLinkedGroup<NotePartGridGroupMetadata>;

export function isNotePartGrid(noteLinkedObject: NoteLinkedObject): noteLinkedObject is NotePartGrid {
  return (
    noteLinkedObject.type === NoteLinkedObjectType.NOTE_LINKED_GROUP &&
    noteLinkedObject.kind === NoteLinkedGroupKind.NOTE_PART_GRID
  );
}

export function isImageFileNotePart(notePart: NotePart): notePart is NotePartWithItem<NoteLinkedFile> {
  return (
    isNotePartWithItem(notePart) &&
    isNoteLinkedFile(notePart.item) &&
    notePart.item.previewFile?.previewType === EXTERNAL_FILE_TYPE.IMAGE
  );
}

/**
 * Cross-entry NotePartGrid paste is intentionally limited to all-image "Images" grids (one or more
 * images). Supporting the other grid-backed note part variants should only require removing or
 * relaxing this guard once their contained note parts have an approved copy/paste contract.
 */
export function isImageNotePartGrid(noteLinkedObject: NoteLinkedObject): noteLinkedObject is NotePartGrid {
  if (!isNotePartGrid(noteLinkedObject)) {
    return false;
  }

  return (
    noteLinkedObject.containedNoteParts.length >= 1 &&
    noteLinkedObject.containedNoteParts.every((notePart) => isImageFileNotePart(notePart))
  );
}
